"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFormStateChanged = exports.camelCaseToTitleCase = exports.commitFormState = exports.setFormStateValues = exports.formStateToJS = exports.BAD_formStateToJS = exports.traverseFormState = exports.getEnumValues = exports.getEnumKeys = exports.enumToOptions = exports.DatetimeFieldState = exports.DropdownSearchFieldState = exports.DropdownFieldState = exports.TextAreaFieldState = exports.InputFieldState = exports.CheckboxFieldState = void 0;
const formstate_1 = require("formstate");
const mobx_1 = require("mobx");
class CheckboxFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        this.onChangeHandler = (_0, checked) => {
            this.onChange(checked);
        };
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.DEPRECATED_onChangeHandler = (_0, data) => {
            this.onChange(!!data.checked);
        };
    }
}
exports.CheckboxFieldState = CheckboxFieldState;
class InputFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        this.onChangeHandler = (_0, data) => {
            this.onChange(data.value);
        };
        this.onChangeNativeHandler = (event) => {
            this.onChange(event.currentTarget.value);
        };
    }
}
exports.InputFieldState = InputFieldState;
class TextAreaFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        /**
         * react-semantic type for onChange event of TextArea component seems to have a bug with data object type
         * so declaring data as any
         */
        this.onChangeHandler = (_0, data) => {
            this.onChange(data.value);
        };
    }
}
exports.TextAreaFieldState = TextAreaFieldState;
class DropdownFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        /**
         * react-semantic type for onChange event of Dropdown component seems to have a bug with data object type
         * so declaring data as any
         */
        this.onChangeHandler = (_0, data) => {
            this.onChange(data.value);
        };
    }
}
exports.DropdownFieldState = DropdownFieldState;
class DropdownSearchFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        this.onChangeHandler = (_0, data) => {
            this.onChange(data.searchQuery);
        };
    }
}
exports.DropdownSearchFieldState = DropdownSearchFieldState;
class DatetimeFieldState extends formstate_1.FieldState {
    constructor() {
        super(...arguments);
        this.onChangeHandler = (event) => {
            this.onChange(event.target.value);
        };
    }
}
exports.DatetimeFieldState = DatetimeFieldState;
function enumToOptions(enumObject, nameProvider) {
    return getEnumKeys(enumObject).map(k => ({
        key: k,
        text: nameProvider ? nameProvider(enumObject[k]) : k,
        value: enumObject[k],
    }));
}
exports.enumToOptions = enumToOptions;
function getEnumKeys(enumObject) {
    let keys = Object.keys(enumObject);
    if (keys.some(k => typeof enumObject[k] === 'number')) {
        keys = keys.filter(k => typeof enumObject[k] === 'number');
    }
    return keys;
}
exports.getEnumKeys = getEnumKeys;
function getEnumValues(enumObject) {
    return getEnumKeys(enumObject).map(k => enumObject[k]);
}
exports.getEnumValues = getEnumValues;
function traverseFormState(recursive, formState, onFormVisit, onFieldVisit) {
    const visitChild = (key, child) => {
        if (child instanceof formstate_1.FormState) {
            if (recursive) {
                traverseFormState(recursive, child, onFormVisit, onFieldVisit);
            }
            if (onFormVisit) {
                onFormVisit(key, child);
            }
        }
        else if (onFieldVisit) {
            onFieldVisit(key, child);
        }
    };
    if (mobx_1.isArrayLike(formState.$)) {
        formState.$.forEach((child, index) => visitChild(index.toString(), child));
    }
    else {
        (mobx_1.isObservableMap(formState.$)
            ? Array.from(formState.$)
            : Object.entries(formState.$)).forEach(([key, child]) => visitChild(key, child));
    }
}
exports.traverseFormState = traverseFormState;
// eslint-disable-next-line @typescript-eslint/naming-convention
function BAD_formStateToJS(formState) {
    const formValues = {};
    traverseFormState(false, formState, (key, form) => (formValues[key] = BAD_formStateToJS(form)), (key, field) => (formValues[key] = mobx_1.toJS(field.value)));
    return formValues;
}
exports.BAD_formStateToJS = BAD_formStateToJS;
function formStateToJS(formState) {
    const formValues = mobx_1.isArrayLike(formState.$) ? [] : {};
    traverseFormState(false, formState, (key, form) => (formValues[key] = formStateToJS(form)), (key, field) => (formValues[key] = mobx_1.toJS(field.$)));
    return formValues;
}
exports.formStateToJS = formStateToJS;
function setFormStateValues(formState, data, triggerValidation = false) {
    if (mobx_1.isArrayLike(formState.$) && data.length !== formState.$.length) {
        throw new Error('Number of elements in data object node is different from number of element in form.' +
            ' All array nodes should match in size before values can be applied to form.');
    }
    mobx_1.transaction(() => {
        traverseFormState(false, formState, (key, form) => {
            if (data instanceof Map || mobx_1.isObservableMap(data)) {
                if (data.has(key)) {
                    setFormStateValues(form, data.get(key));
                }
            }
            else {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    setFormStateValues(form, data[key]);
                }
            }
        }, (key, field) => {
            if (data instanceof Map || mobx_1.isObservableMap(data)) {
                if (data.has(key)) {
                    mobx_1.runInAction(() => {
                        field.value = data.get(key);
                        field.$ = data.get(key);
                    });
                }
            }
            else {
                if (Object.prototype.hasOwnProperty.call(data, key)) {
                    mobx_1.runInAction(() => {
                        field.value = data[key];
                        field.$ = data[key];
                    });
                }
            }
        });
        if (triggerValidation) {
            const setValidatedSubFields = (form) => {
                form.validatedSubFields = form.getValues();
            };
            traverseFormState(true, formState, (_0, form) => {
                setValidatedSubFields(form);
            });
            setValidatedSubFields(formState);
            formState.validate();
        }
    });
    return formState;
}
exports.setFormStateValues = setFormStateValues;
function commitFormState(formState) {
    traverseFormState(true, formState, undefined, (_0, field) => {
        field.dirty = false;
        field._initValue = field.value;
    });
}
exports.commitFormState = commitFormState;
function camelCaseToTitleCase(value) {
    const regexp = /[A-Z](?=[A-Z][a-z])|[^A-Z](?=[A-Z])|[A-Za-z](?=[^A-Za-z])/g;
    return value.replace(regexp, '$& ');
}
exports.camelCaseToTitleCase = camelCaseToTitleCase;
function isFormStateChanged(formState) {
    return mobx_1.computed(() => {
        let isChanged = false;
        traverseFormState(true, formState, undefined, (_0, field) => {
            const isValueChanged = () => {
                if (field instanceof InputFieldState) {
                    if (field._initValue === undefined && field.value === '') {
                        return false;
                    }
                }
                return !mobx_1.comparer.structural(field._initValue, field.value);
            };
            isChanged = isChanged || (field.dirty === true && isValueChanged());
        });
        return isChanged;
    });
}
exports.isFormStateChanged = isFormStateChanged;
//# sourceMappingURL=form-helpers.js.map